
import { Vue, Component } from 'vue-property-decorator';
import Banner from '@/components/common/banner.vue';
import FootBox from '@/components/common/footBox.vue';

@Component({
    components: {
        Banner,
        FootBox,
    },
})
export default class Solution extends Vue {}
